import { Fragment, useState, useEffect } from "react";
import Footer from "../../../footer";
import Navigation from "../../../navbar";
import ArticleContainer from "./components";
import FeaturedImage from "./components/featured-image/FeaturedImage";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import "./SingleBlog.css";
import { HelmetProvider } from 'react-helmet-async';
import SEO from "../../../../utils/seo/SEO";
import SkeletonComponent from "../../../../utils/skeleton-component/SkeletonComponent";
import { toast } from "react-toastify";
import { useGetBlogsDataByID, useGetBlogsDataBySlug } from "../../../../api/blog.api";
import useHyphenCheck from "../../../../hooks/useHyphenCheck";









export default function SingleBlog() {


  const [title, setTitle] = useState("Eraconneckt | Blog");
  const [blogData, setBlogData] = useState([]);

  let { id } = useParams();
  const isHyphenated = useHyphenCheck(id);


  const {
    status: statusBySlug,
    data: dataBySlug,
    error: errorBySlug
  } = useGetBlogsDataBySlug(id);


  const {
    status: statusById,
    data: dataById,
    error: errorById
  } = useGetBlogsDataByID(id);



  useEffect(() => {
    if (statusBySlug === "success") {
      setBlogData(dataBySlug?.data);
      setTitle(`${blogData?.blogTitle} | Eraconneckt Blog`);
    } else if (statusById === "success") {
      setBlogData(dataById?.data);
      setTitle(`${blogData?.blogTitle} | Eraconneckt Blog`);
    }
  }, [blogData?.blogTitle, dataById?.data, dataBySlug?.data, statusById, statusBySlug])

  isHyphenated ? (statusBySlug === "error" && toast.error(errorBySlug?.response?.data?.error)) : (statusById === "error" && toast.error(errorById));



  useEffect(() => {
    // This will run when the page first loads and whenever the title changes
    document.title = title;
  }, [title]);



  return (
    <>
      <HelmetProvider>
        <SEO
          title={`${blogData?.blogTitle} | Eraconneckt`}
          description={`${blogData?.blogTitle} | Eraconneckt`}
          name={`Eraconneckt`}
          type={`Article`}
          image={blogData?.featuredImage}
          link={window.location.href}
        />
        <Navigation />

        <PageContainer>
          {((isHyphenated && statusBySlug === "pending") || (!isHyphenated && statusById === "pending")) ?

            (
              <SkeletonComponent count={24} />
            ) : (
              <Fragment
                key={blogData?.id}
              >

                <FeaturedImage
                  featuredImage={blogData?.featuredImage}
                />

                <ArticleContainer
                  blogTitle={blogData?.blogTitle}
                  blogBody={blogData?.blogBody}
                  date={blogData?.date}
                  author={blogData?.author}
                />

              </Fragment>
            )}

        </PageContainer>


        <Footer />
      </HelmetProvider>
    </>
  )
};










const PageContainer = styled.div`
  min-height: 100vh;
`;
